module.exports = __webpack_public_path__ + "img/xperio.a066bc3c.jpg";